import { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import { lightGreen } from '@mui/material/colors'
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import Wallets from './Wallets';
import { HFlex } from './Layout.jsx';
import Box from '@mui/material/Box';
import { account, fsm } from '../state/index.js';
import { useNavigate, useLocation } from 'react-router-dom';
import Button from '@mui/material/Button';
import logo from '../images/logo64.png';
import { afterRoyalT } from '../constants.js';
import Badge from '@mui/material/Badge';
import { govEnd } from '../constants.js';

function MenuButton({ route, children, sx }) {
  const navigate = useNavigate();
  const location = useLocation();
  const onClick = () => {
    navigate(route);
  }
  const active = location.pathname.startsWith(route);
  const color = active ? 'var(--primary)' : 'transparent';
  return <Button sx={{borderBottom: `1px ${color} solid`, ...sx}} onClick={onClick}>{children}</Button>;
}

function Header() {
  const activeRoyalT = Date.now() < afterRoyalT;
  const navigate = useNavigate();
  const navigateHome = () => navigate('/');
  return <AppBar position="static" sx={{pt: 1, backgroundColor: 'white', pb: 1 }}>
    <HFlex sx={{ display: 'flex', position: 'relative', flexDirection: { xs: 'column-reverse', md: 'row' }}}>
      <Button onClick={navigateHome} size='small' sx={{position: 'absolute', transform: { xs: 'translate(10%, -50%)', md: 'translate(25%, -50%)' }, top: '50%', left: 0, display: { xs: 'inline-block', md: 'none'}}}>
        <img src={logo} />
      </Button>
      <Button onClick={navigateHome} size='small' sx={{ml: 2, display: { xs: 'none', md: 'inline-block'}}}>
        <Typography className="maldini-style" color="primary" sx={{fontSize: { xs: '2rem', md: '2.5rem' }, lineHeight: '2rem', marginTop: '2px', marginBottom: '-4px'}} >
          CUPSTAKES.WORLD
        </Typography>
      </Button>
      <HFlex sx={{ flexGrow: 1, alignSelf: { xs: 'flex-end', md: 'center' },  mt: { xs: 1, md: 0 } }}>
        <MenuButton route="/redeem">REDEEM</MenuButton>
        <MenuButton route="/data">DATA</MenuButton>
        <MenuButton route="/audit">AUDIT</MenuButton>
        <MenuButton route="/trade">TRADE</MenuButton>
        <MenuButton route="/faq">FAQ</MenuButton>
      </HFlex>
      <Box sx={{mr: 1, ml: 1}}>
        <Wallets account={account} fsm={fsm} />
      </Box>
    </HFlex>
  </AppBar>
}

export default Header;
